import { $, addAction, INIT } from '@situation/setdesign.util';
import CalendarController from '../shared/calendar/CalendarController';
import CalendarPrint from '../shared/calendar/CalendarPrint';
import CalendarState from '../shared/calendar/CalendarState';
import CalendarView from '../shared/calendar/CalendarView';
import EventList from '../shared/calendar/EventList';

addAction(INIT, () => {
    const $container = $('.calendar-container');
    if ($container.length && $.isFunction(jQuery.fn.fullCalendar)) {
        // eslint-disable-next-line no-new
        new CalendarPrint($container);
        const eventList = new EventList($container.data('filterGroup'));
        // eslint-disable-next-line no-new
        new CalendarState();
        // eslint-disable-next-line no-new
        new CalendarView();
        // eslint-disable-next-line no-new
        new CalendarController($container, eventList);
    }
});
